import { render, staticRenderFns } from "./my-dialog.vue?vue&type=template&id=a37e2456"
import script from "./my-dialog.vue?vue&type=script&lang=js"
export * from "./my-dialog.vue?vue&type=script&lang=js"
import style0 from "./my-dialog.vue?vue&type=style&index=0&id=a37e2456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports